<div
  class="flex flex-col gap-1 p-2 border-b border-[#ccc] cursor-pointer user-list-item"
  [class.selected]="isSelected"
  [routerLink]="['/admin', 'users']"
  [queryParams]="{ userId: user.user_id }"
>
  <div class="flex flex-row justify-between items-start w-full">
    <p class="font-semibold">{{ user | userDisplay }}</p>
    @if (!user.is_active) {
      <span class="bg-gray-500 rounded-[0.25rem] py-1 px-2 text-xs text-white font-bold"> Inactive </span>
    }
  </div>
  <p class="italic">{{ user.email }}</p>
  <p>
    {{ userGroupsText }}
  </p>
  <div class="flex flex-row gap-1 flex-wrap">
    @for (client of clients; track client) {
      <span class="bg-[#228cdb] rounded-[0.25rem] py-1 px-2 text-xs text-white font-bold">
        {{ client }}
      </span>
    }
  </div>
</div>
